export enum IdViewListOption {
  PACCHI_IN_GIACENZA = '0',
  STORICO = '1',
}

export enum LabelViewListOption {
  PACCHI_IN_GIACENZA = 'Pacchi in giacenza',
  STORICO = 'Storico',
}

export enum IdStateListOption {
  TUTTI = '0',
  ACCETTATO_DAL_CLIENTE = '1',
  RIFIUTATO_DAL_CLIENTE = '2',
  DA_CONSEGNARE_AL_CLIENTE = '3',
  COMPIUTA_GIACENZA = '4',
  IN_VERIFICA = '5',
}

export enum LabelStateListOption {
  TUTTI = 'Tutti',
  ACCETTATO_DAL_CLIENTE = 'Accettato dal cliente',
  RIFIUTATO_DAL_CLIENTE = 'Rifiutato dal cliente',
  DA_CONSEGNARE_AL_CLIENTE = 'Da consegnare al cliente',
  COMPIUTA_GIACENZA = 'Compiuta giacenza',
  IN_VERIFICA = 'In verifica',
}

export enum IdStateHistoricalListOption {
  TUTTI = '1',
  ACCETTAZIONE = '2',
  ACCETTAZIONE_STAMPA = '3',
  ACCETTAZIONE_RESO = '4',
  ACCETTAZIONE_RESO_STAMPA = '5',
  CONSEGNA_PACCO_GIACENZA = '6',
  CONSEGNA_ANOMALIA = '7',
  PACCO_SMARRITO = '8',
  PACCO_VENDUTO = '9',
  ACCETTAZIONE_RESO_BOXLESS = '1O',
  ACCETTAZIONE_CONTO_DEPOSITO = '11',
  OGGETTI_CONTO_DEPOSITO = '12',
  ACCETTAZIONE_BOXLESS_SECOND_HAND = '13',
}

export enum LabelStateHistoricalListOption {
  TUTTI = 'Tutti',
  ACCETTAZIONE = 'Accettazione',
  ACCETTAZIONE_STAMPA = 'Accettazione - stampa',
  ACCETTAZIONE_RESO = 'Accettazione reso',
  ACCETTAZIONE_RESO_STAMPA = 'Accettazione reso - stampa',
  CONSEGNA_PACCO_GIACENZA = 'Consegna pacco e compiuta giacenza',
  CONSEGNA_ANOMALIA = 'Consegnato in anomalia',
  PACCO_SMARRITO = 'Pacco smarrito',
  PACCO_VENDUTO = 'Pacco Venduto',
  ACCETTAZIONE_RESO_BOXLESS = 'Accettazione reso boxless AMZ',
  ACCETTAZIONE_CONTO_DEPOSITO = 'Accettazione oggetti in conto deposito',
  OGGETTI_CONTO_DEPOSITO = 'Oggetti in conto deposito smarriti',
  ACCETTAZIONE_BOXLESS_SECOND_HAND = 'Accettazione boxless Second Hand',
}

export enum IdFillBoxOption {
  SCANSIONA_OGGETTO = '0',
  OGGETTO_SCATOLA = '1',
  OGGETTO_SMARRITO = '2'
}

export enum LabelFillBoxOption {
  SCANSIONA_OGGETTO = 'Scansiona codice oggetto',
  OGGETTO_SCATOLA = 'Oggetto nella scatola',
  OGGETTO_SMARRITO = 'Oggetto smarrito',
}
